var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftTravelMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 463,
    viewBox: "0 0 200 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1652 92.5301C92.1589 115.247 118.415 169.685 135.998 214.074C153.013 257.03 128.869 290.67 114.903 334.712C99.7969 382.352 104.075 433.689 56.0123 447.389C9.97391 460.512 8.33483 376.656 -34.4398 355.161C-71.3584 336.608 -149.351 366.415 -172.806 332.399C-202.382 289.506 -258.234 216.117 -244.6 165.831C-229.965 111.849 -138.743 147.43 -86.1183 128.485C-35.8969 110.405 3.21772 67.133 50.1652 92.5301Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0005 108.835C83.8584 129.315 107.529 178.39 123.381 218.406C138.72 257.131 116.954 287.457 104.365 327.16C90.7469 370.107 94.6045 416.386 51.2753 428.736C9.77143 440.566 8.29296 364.971 -30.269 345.593C-63.5517 328.867 -133.863 355.738 -155.008 325.072C-181.671 286.404 -232.023 220.244 -219.733 174.912C-206.539 126.248 -124.301 158.325 -76.8599 141.246C-31.585 124.948 3.67671 85.9395 46.0005 108.835Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8822 119.496C77.882 138.429 99.7679 183.793 114.424 220.783C128.608 256.579 108.487 284.611 96.8508 321.31C84.2637 361.007 87.8326 403.786 47.7765 415.199C9.40788 426.132 8.03686 356.255 -27.6138 338.34C-58.3837 322.878 -123.383 347.712 -142.932 319.365C-167.584 283.62 -214.137 222.463 -202.778 180.56C-190.583 135.577 -114.555 165.233 -70.6973 149.449C-28.8427 134.386 3.75365 98.3299 42.8822 119.496Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1497 133.06C67.0692 149.241 85.788 187.992 98.3254 219.59C110.458 250.168 93.2693 274.103 83.3342 305.444C72.5875 339.346 75.6501 375.885 41.4177 385.621C8.6274 394.948 7.43553 335.266 -23.04 319.955C-49.3433 306.739 -104.891 327.931 -121.608 303.715C-142.687 273.178 -182.494 220.93 -172.797 185.144C-162.387 146.728 -97.3976 172.079 -59.9174 158.61C-24.1489 145.757 3.70071 114.971 37.1497 133.06Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5815 144.491C64.8315 159.233 81.8693 194.558 93.2788 223.363C104.32 251.238 88.6521 273.068 79.5896 301.648C69.7868 332.562 72.5629 365.876 41.3742 374.766C11.4994 383.282 10.4361 328.867 -17.3207 314.918C-41.2774 302.879 -91.888 322.222 -107.108 300.148C-126.299 272.314 -162.542 224.691 -153.695 192.059C-144.197 157.029 -85.0031 180.118 -50.8543 167.824C-18.2651 156.091 7.11699 128.011 37.5815 144.491Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8566 158.221C57.6125 171.073 72.4624 201.879 82.406 226.998C92.0285 251.307 78.366 270.347 70.4613 295.273C61.9108 322.235 64.3269 351.287 37.134 359.044C11.0868 366.475 10.1667 319.019 -14.0312 306.858C-34.9163 296.361 -79.0434 313.237 -92.3098 293.988C-109.039 269.716 -140.631 228.188 -132.913 199.729C-124.628 169.178 -73.0229 189.306 -43.2488 178.58C-14.8345 168.344 7.29826 143.852 33.8566 158.221Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7472 166.784C55.4067 178.503 68.9438 206.597 78.0079 229.505C86.7794 251.674 74.3199 269.04 67.1098 291.773C59.3108 316.364 61.5109 342.86 36.7156 349.937C12.9648 356.717 12.1306 313.437 -9.93197 302.348C-28.9741 292.777 -69.211 308.172 -81.3055 290.618C-96.5564 268.484 -125.358 230.613 -118.318 204.657C-110.761 176.793 -63.7091 195.145 -36.5599 185.36C-10.6506 176.021 9.5326 153.682 33.7472 166.784Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1833 192.756C44.4278 201.004 53.9572 220.772 60.3383 236.891C66.5133 252.489 57.746 264.707 52.6737 280.702C47.1869 298.003 48.7375 316.646 31.2877 321.624C14.5729 326.392 13.9822 295.94 -1.54584 288.136C-14.9481 281.4 -43.2647 292.229 -51.778 279.877C-62.5131 264.302 -82.7864 237.653 -77.8341 219.391C-72.5178 199.786 -45.4305 200.316 -26.3243 193.433C-8.09069 186.865 12.1405 183.535 29.1833 192.756Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2633 204.262C38.5208 210.887 46.1966 226.742 51.3392 239.67C56.3157 252.18 52.9526 263.582 45.2211 274.783C41.935 277.731 41.6914 278.335 34.9793 280.238C21.5525 284.044 14.1446 286.961 1.65966 280.691C-9.11603 275.279 -31.8599 283.933 -38.7123 274.024C-47.3531 261.528 -63.6686 240.147 -59.7062 225.513C-55.4526 209.802 -33.686 210.252 -18.3395 204.753C-3.69387 199.504 12.5599 196.854 26.2633 204.262Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1899 214.623C28.2651 219.515 33.979 231.165 37.8131 240.661C41.5235 249.85 39.0682 258.205 33.3844 266.401C30.9638 268.554 30.7854 268.997 25.8304 270.375C15.9186 273.132 10.452 275.252 1.20967 270.62C-6.76739 266.622 -23.5515 272.91 -28.6412 265.624C-35.0593 256.435 -47.1721 240.709 -44.2825 229.985C-41.1805 218.473 -25.0946 218.86 -13.7686 214.866C-2.9598 211.055 9.04415 209.154 19.1899 214.623Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0608 224.143C17.4687 227.054 20.8829 233.969 23.1758 239.605C25.3946 245.058 23.9421 250.01 20.5675 254.864C19.1289 256.139 19.0232 256.401 16.0749 257.213C10.1774 258.837 5.76855 262.186 2.48978 261.936C-0.788992 261.686 -1.55094 264.694 -16.3575 254.335C-20.1882 248.879 -27.4162 239.54 -25.7077 233.183C-23.8737 226.36 -14.2973 226.607 -7.5592 224.251C-1.12887 222.002 6.01505 220.888 12.0608 224.143Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33297 229.137C13.2604 231.251 15.7424 236.266 17.4097 240.353C19.0231 244.308 20.4042 248.797 15.5232 251.415C14.4794 252.339 14.4028 252.529 12.2627 253.116C7.98185 254.291 4.78262 256.716 2.40211 256.534C0.0215976 256.351 -5.12136 257.758 -11.2846 251.014C-14.0683 247.057 -19.3202 240.282 -18.0828 235.674C-16.7545 230.728 -9.80188 230.911 -4.91116 229.207C-0.243788 227.579 4.94218 226.775 9.33297 229.137Z",
    fill: "#C4C4C4",
    fillOpacity: 0.05,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTravelMonth);
export default __webpack_public_path__ + "static/media/Left-TravelMonth.9cd0403bcc9641780ac2e54828a57b60.svg";
export { ForwardRef as ReactComponent };